import {messages as portugueseMessages} from './languages/pt'
import {messages as englishMessages} from './languages/en'
import {messages as spanishMessages} from './languages/es'

const messages = {
    ...portugueseMessages,
    ...englishMessages,
    ...spanishMessages
}

export {messages}